"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMainPropType = exports.SleepsInfoPropTypes = exports.SleepsInfoDefaultValues = exports.RoomCardPropTypes = exports.RoomCardDefaultValues = exports.RateInfoPropTypes = exports.RateInfoDefaultValues = exports.RateDetailModalPropTypes = exports.RateDetailModalDefaultValues = exports.PriceInfoPropTypes = exports.PriceInfoDefaultValues = exports.OptionsAndBenefitsInfoPropTypes = exports.OptionsAndBenefitsInfoDefaultValues = exports.IncludedInPriceInfoPropTypes = exports.IncludedInPriceInfoDefaultValues = exports.ImageGalleryModalPropTypes = exports.ImageGalleryModalDefaultValues = exports.AllAmenitiesModalPropTypes = exports.AllAmenitiesModalDefaultValues = void 0;
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _propTypes = _interopRequireDefault(require("prop-types"));
var getMainPropType = {
  imageList: _propTypes.default.instanceOf(Array),
  isMobile: _propTypes.default.bool
};
exports.getMainPropType = getMainPropType;
var IncludedInPriceInfoPropTypes = {
  amenities: _propTypes.default.instanceOf(Array),
  moreDetails: _propTypes.default.string,
  option: _propTypes.default.string,
  index: _propTypes.default.number,
  benefitsIncluded: _propTypes.default.string,
  theme: _propTypes.default.string,
  roomOccupancy: _propTypes.default.object
};
exports.IncludedInPriceInfoPropTypes = IncludedInPriceInfoPropTypes;
var IncludedInPriceInfoDefaultValues = {
  amenities: [],
  moreDetails: null,
  option: null,
  index: 0,
  benefitsIncluded: null,
  theme: _constant.DEFAULT_THEME,
  roomOccupancy: {}
};
exports.IncludedInPriceInfoDefaultValues = IncludedInPriceInfoDefaultValues;
var OptionsAndBenefitsInfoPropTypes = {
  rateName: _propTypes.default.string,
  isShowRateName: _propTypes.default.bool,
  icon: _propTypes.default.string,
  primaryText: _propTypes.default.string,
  secondaryText: _propTypes.default.string,
  color: _propTypes.default.string,
  promoTitle: _propTypes.default.string,
  cancellationPenaltyType: _propTypes.default.string,
  theme: _propTypes.default.string,
  index: _propTypes.default.number,
  withTooltip: _propTypes.default.bool,
  option: _propTypes.default.string,
  toolTipCancellationHeaderText: _propTypes.default.string,
  toolTipCancellationBodyText: _propTypes.default.string,
  freeCancellationText: _propTypes.default.string,
  freeCancellation: _propTypes.default.string,
  payLaterText: _propTypes.default.string,
  payLater: _propTypes.default.string,
  nonRefundableText: _propTypes.default.string,
  nonRefundable: _propTypes.default.string,
  partiallyRefundableText: _propTypes.default.string,
  partiallyRefundable: _propTypes.default.string,
  payAtHotel: _propTypes.default.string,
  payAtHotelText: _propTypes.default.string,
  instantConfirmationText: _propTypes.default.string,
  roomOccupancy: _propTypes.default.object,
  isSnap: _propTypes.default.bool,
  bedGroupsOptions: _propTypes.default.instanceOf(Array),
  amenities: _propTypes.default.instanceOf(Array),
  showIncludedInPriceInfo: _propTypes.default.bool,
  messageFOMO: _propTypes.default.string,
  isSoldOut: _propTypes.default.bool,
  lowInventoryFOMO: _propTypes.default.instanceOf(Object),
  isBogoPromoEnabled: _propTypes.default.bool,
  bogoMessage: _propTypes.default.string,
  payNowMessage: _propTypes.default.string,
  isPayNowEnabled: _propTypes.default.bool
};
exports.OptionsAndBenefitsInfoPropTypes = OptionsAndBenefitsInfoPropTypes;
var OptionsAndBenefitsInfoDefaultValues = {
  rateName: null,
  isShowRateName: false,
  icon: null,
  primaryText: null,
  secondaryText: null,
  color: null,
  theme: _constant.DEFAULT_THEME,
  index: _propTypes.default.number,
  withTooltip: false,
  option: null,
  cancellationPenaltyType: null,
  freeCancellationText: null,
  freeCancellation: null,
  payLaterText: null,
  payLater: null,
  nonRefundableText: null,
  nonRefundable: null,
  partiallyRefundableText: null,
  partiallyRefundable: null,
  payAtHotel: null,
  payAtHotelText: null,
  instantConfirmationText: null,
  roomOccupancy: {},
  isSnap: false,
  amenities: [],
  bedGroupsOptions: [],
  showIncludedInPriceInfo: false,
  messageFOMO: '',
  isSoldOut: false,
  lowInventoryFOMO: {},
  isBogoPromoEnabled: false,
  bogoMessage: '',
  payNowMessage: '',
  isPayNowEnabled: false
};
exports.OptionsAndBenefitsInfoDefaultValues = OptionsAndBenefitsInfoDefaultValues;
var PriceInfoPropTypes = {
  theme: _propTypes.default.string,
  discountText: _propTypes.default.string,
  CTAButtonText: _propTypes.default.string,
  perGuestText: _propTypes.default.string,
  snapPriceText: _propTypes.default.string,
  onSelectRateHandler: _propTypes.default.func.isRequired,
  strikeThrough: _propTypes.default.instanceOf(Object),
  baseRate: _propTypes.default.instanceOf(Object).isRequired,
  price: _propTypes.default.instanceOf(Object).isRequired,
  totalPrice: _propTypes.default.instanceOf(Object).isRequired,
  locale: _propTypes.default.string,
  includeTaxText: _propTypes.default.string,
  bigPoint: _propTypes.default.instanceOf(Object),
  isSoldOut: _propTypes.default.bool
};
exports.PriceInfoPropTypes = PriceInfoPropTypes;
var PriceInfoDefaultValues = {
  theme: _constant.DEFAULT_THEME,
  discountText: null,
  CTAButtonText: null,
  onSelectRateHandler: function onSelectRateHandler() {},
  strikeThrough: {},
  price: {},
  totalPrice: {},
  locale: null,
  perGuestText: null,
  snapPriceText: null,
  includeTaxText: null,
  bigPoint: {},
  isSoldOut: false
};
exports.PriceInfoDefaultValues = PriceInfoDefaultValues;
var RateInfoPropTypes = {
  isShowRateName: _propTypes.default.bool,
  theme: _propTypes.default.string,
  promoTitle: _propTypes.default.string,
  discountType: _propTypes.default.string,
  rate: _propTypes.default.isRequired,
  withTooltip: _propTypes.default.bool,
  index: _propTypes.default.number,
  translations: _propTypes.default.instanceOf(Object).isRequired,
  occupancy: _propTypes.default.instanceOf(Object).isRequired,
  onSelectRoomHandler: _propTypes.default.func.isRequired,
  isHasSingleOption: _propTypes.default.bool,
  roomOccupancy: _propTypes.default.instanceOf(Object).isRequired,
  isSnap: _propTypes.default.bool,
  includedInPriceHeader: _propTypes.default.bool,
  showSleepsInfoSection: _propTypes.default.bool,
  soldOutBedGroupTokens: _propTypes.default.instanceOf(Array),
  lowInventoryFOMO: _propTypes.default.instanceOf(Object),
  isBogoPromoEnabled: _propTypes.default.bool,
  bogoMessage: _propTypes.default.string,
  bogoTag: _propTypes.default.string,
  payNowMessage: _propTypes.default.string,
  isPayNowEnabled: _propTypes.default.bool
};
exports.RateInfoPropTypes = RateInfoPropTypes;
var RateInfoDefaultValues = {
  isShowRateName: false,
  theme: _constant.DEFAULT_THEME,
  promoTitle: null,
  discountType: null,
  rate: {
    isPayAtHotel: false,
    isPayLater: false
  },
  index: 0,
  translations: {},
  occupancy: {},
  onSelectRoomHandler: function onSelectRoomHandler() {},
  isHasSingleOption: false,
  roomOccupancy: {},
  isSnap: false,
  includedInPriceHeader: true,
  showSleepsInfoSection: false,
  soldOutBedGroupTokens: [],
  lowInventoryFOMO: {},
  isBogoPromoEnabled: false,
  bogoMessage: '',
  bogoTag: '',
  payNowMessage: '',
  isPayNowEnabled: false
};
exports.RateInfoDefaultValues = RateInfoDefaultValues;
var SleepsInfoPropTypes = {
  theme: _propTypes.default.string,
  occupancy: _propTypes.default.instanceOf(Object).isRequired,
  roomOccupancy: _propTypes.default.instanceOf(Object).isRequired,
  showSleepsInfoSection: _propTypes.default.bool
};
exports.SleepsInfoPropTypes = SleepsInfoPropTypes;
var SleepsInfoDefaultValues = {
  theme: _constant.DEFAULT_THEME,
  occupancy: {},
  roomOccupancy: {},
  showSleepsInfoSection: false
};
exports.SleepsInfoDefaultValues = SleepsInfoDefaultValues;
var RoomCardPropTypes = {
  accessible: _propTypes.default.bool,
  amenities: _propTypes.default.instanceOf(Array),
  images: _propTypes.default.instanceOf(Array),
  rates: _propTypes.default.instanceOf(Array).isRequired,
  isShowRateName: _propTypes.default.bool,
  seeAllAmenities: _propTypes.default.string.isRequired,
  withTooltip: _propTypes.default.bool,
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  theme: _propTypes.default.string,
  heroImage: _propTypes.default.string.isRequired,
  onLoadImage: _propTypes.default.func,
  isImageGalleryEnabled: _propTypes.default.bool,
  translations: _propTypes.default.instanceOf(Object).isRequired,
  occupancy: _propTypes.default.instanceOf(Object).isRequired,
  onSelectRoom: _propTypes.default.func.isRequired,
  locale: _propTypes.default.string,
  isHasSingleOption: _propTypes.default.bool,
  roomOccupancy: _propTypes.default.instanceOf(Object).isRequired,
  isSnap: _propTypes.default.bool,
  bedGroupsOptions: _propTypes.default.instanceOf(Array),
  roomsLeft: _propTypes.default.string,
  showSleepsInfoSection: _propTypes.default.bool,
  showIncludedInPriceInfo: _propTypes.default.bool,
  rateDiscounts: _propTypes.default.arrayOf({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    type: _propTypes.default.string
  }),
  soldOutBedGroupTokens: _propTypes.default.instanceOf(Array),
  lowInventoryFOMO: _propTypes.default.instanceOf(Object),
  isBogoPromoEnabled: _propTypes.default.bool,
  bogoMessage: _propTypes.default.string,
  bogoTag: _propTypes.default.string,
  payNowMessage: _propTypes.default.string,
  isPayNowEnabled: _propTypes.default.bool,
  getTranslatedPricebreakdownData: _propTypes.default.func,
  isBlockedRateIsEnabled: _propTypes.default.bool
};
exports.RoomCardPropTypes = RoomCardPropTypes;
var RoomCardDefaultValues = {
  accessible: false,
  amenities: [],
  images: [],
  rates: [],
  isShowRateName: false,
  seeAllAmenities: null,
  id: null,
  name: null,
  theme: _constant.DEFAULT_THEME,
  heroImage: null,
  onLoadImage: function onLoadImage() {},
  isImageGalleryEnabled: false,
  translations: {},
  occupancy: {},
  onSelectRoom: function onSelectRoom() {},
  locale: null,
  isHasSingleOption: false,
  roomOccupancy: {},
  isSnap: false,
  bedGroupsOptions: {},
  roomsLeft: null,
  showSleepsInfoSection: false,
  showIncludedInPriceInfo: false,
  rateDiscounts: [],
  soldOutBedGroupTokens: [],
  lowInventoryFOMO: {},
  isBogoPromoEnabled: false,
  bogoMessage: '',
  bogoTag: '',
  payNowMessage: '',
  isPayNowEnabled: false,
  getTranslatedPricebreakdownData: function getTranslatedPricebreakdownData() {},
  isBlockedRateIsEnabled: false
};
exports.RoomCardDefaultValues = RoomCardDefaultValues;
var ImageGalleryModalPropTypes = {
  isMobile: _propTypes.default.bool,
  images: _propTypes.default.instanceOf(Array),
  name: _propTypes.default.string.isRequired,
  amenities: _propTypes.default.instanceOf(Array),
  theme: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  address: _propTypes.default.instanceOf(Object).isRequired,
  allText: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  zIndex: _propTypes.default.number
};
exports.ImageGalleryModalPropTypes = ImageGalleryModalPropTypes;
var ImageGalleryModalDefaultValues = {
  isMobile: false,
  images: [],
  name: null,
  amenities: [],
  theme: _constant.DEFAULT_THEME,
  onClose: function onClose() {},
  address: {},
  allText: null,
  isOpen: false,
  zIndex: 10
};
exports.ImageGalleryModalDefaultValues = ImageGalleryModalDefaultValues;
var AllAmenitiesModalPropTypes = {
  theme: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool,
  heroImage: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  address: _propTypes.default.instanceOf(Object).isRequired,
  amenities: _propTypes.default.instanceOf(Array),
  openImageGallery: _propTypes.default.func.isRequired,
  translations: _propTypes.default.instanceOf(Object).isRequired,
  zIndex: _propTypes.default.number
};
exports.AllAmenitiesModalPropTypes = AllAmenitiesModalPropTypes;
var AllAmenitiesModalDefaultValues = {
  theme: _constant.DEFAULT_THEME,
  onClose: function onClose() {},
  isOpen: false,
  heroImage: null,
  name: null,
  address: {},
  amenities: [],
  openImageGallery: function openImageGallery() {},
  translations: {},
  zIndex: 10
};
exports.AllAmenitiesModalDefaultValues = AllAmenitiesModalDefaultValues;
var RateDetailModalPropTypes = {
  theme: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool,
  rate: _propTypes.default.instanceOf(Object).isRequired,
  heroImage: _propTypes.default.string,
  address: _propTypes.default.instanceOf(Object).isRequired,
  onSelectRoomHandler: _propTypes.default.func.isRequired,
  name: _propTypes.default.string,
  locale: _propTypes.default.string,
  translations: _propTypes.default.instanceOf(Object).isRequired,
  zIndex: _propTypes.default.number,
  isSnap: _propTypes.default.bool
};
exports.RateDetailModalPropTypes = RateDetailModalPropTypes;
var RateDetailModalDefaultValues = {
  theme: _constant.DEFAULT_THEME,
  onClose: function onClose() {},
  isOpen: false,
  rate: {},
  heroImage: null,
  address: {},
  onSelectRoomHandler: function onSelectRoomHandler() {},
  name: null,
  locale: null,
  translations: {},
  zIndex: 10,
  isSnap: false
};
exports.RateDetailModalDefaultValues = RateDetailModalDefaultValues;